<div class="row left-menu">
  <div class="menu-content">
    <p class="menu">{{ "patientEducation.browseByTopic" | cxTranslate }}</p>
    @for (catalog of catalogTypes; track catalog) {
      <div class="list">
        @if (catalog.subcategories.length==0) {
          <div>
            <p class="sub-title sub-heading">
              <a data-id={{catalog.name}}_0 class="clickClass" (click)="getCatalogType(catalog.id, event)">{{
                catalog.name
              }}</a>
            </p>
          </div>
        }
        @if (catalog.subcategories.length>0) {
          <div>
            <p class="head-title text">{{catalog.name}}
            </p>
            @for (list of catalog.subcategories; track list; let i = $index) {
              <p class="sub-title sub-heading">
                <a data-id={{catalog.name}}_{{i+1}} class="clickClass" (click)="getCatalogType(list.id, event)">{{
                  list.name
                }}</a>
              </p>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="dropdown-list">
  <ng-select name="browseByTopic" [items]="catalogTypes" [searchable]="false" bindLabel="name" bindValue="id"
    placeholder="Browse by topic" class="dropdown-list" [(ngModel)]="selectedtype">
    <ng-template ng-option-tmp let-item="item">
      <span class="dropdown-text">{{item.name}}</span>
      <hr class="hr-style">
      @for (itemObj of item.subcategories; track itemObj) {
        <div class="pt-3 pb-3 category-style"
          (click)="getCatalogType(itemObj.id, event)">
          {{itemObj.name}}
        </div>
      }
    </ng-template>
  </ng-select>
</div>